package com.rainbowclubs.rainbow.presentation.login

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.rainbowclubs.rainbow.domain.use_cases.club.GetSelectedClubIdUseCase
import com.rainbowclubs.rainbow.domain.use_cases.login.LoginUseCase
import com.rainbowclubs.rainbow.presentation.ScreenState
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

class LoginViewModel(
    private val loginUseCase: LoginUseCase,
    private val getSelectedClubIdUseCase: GetSelectedClubIdUseCase,
) : ViewModel() {

    private var uiModel = LoginUIModel()
    private val _screenState: MutableStateFlow<ScreenState<LoginUIModel>> =
        MutableStateFlow(ScreenState.Content(uiModel))
    val screenState: StateFlow<ScreenState<LoginUIModel>> = _screenState

    private val _events: MutableSharedFlow<LoginEvents> =
        MutableSharedFlow()
    val events: SharedFlow<LoginEvents> = _events


    fun updateEmail(newEmail: String) {
        uiModel = uiModel.copy(
            email = newEmail
        )
        _screenState.value = ScreenState.Content(uiModel)
    }

    fun updatePassword(newPassword: String) {
        uiModel = uiModel.copy(
            password = newPassword
        )
        _screenState.value = ScreenState.Content(uiModel)
    }

    fun login() {
        // TODO validate the inputs before sending
        viewModelScope.launch {
            _screenState.value = ScreenState.Loading
            val authResult = loginUseCase.login(
                uiModel.email.orEmpty(),
                uiModel.password.orEmpty(),
            )

            authResult.onSuccess {
                val cachedClubId = getSelectedClubIdUseCase()
                if (cachedClubId.isNullOrBlank()) {
                    _events.emit(LoginEvents.NavigateToSelectClub())
                } else {
                    _events.emit(LoginEvents.NavigateToHome(cachedClubId))
                }
            }.onFailure { e ->
                _screenState.value = ScreenState.Error(e)
            }
        }
    }

    fun tryAgain() {
        _screenState.value = ScreenState.Content(uiModel)
    }

    fun onPasswordVisibilityClicked() {
        uiModel = uiModel.copy(
            passwordVisible = !uiModel.passwordVisible
        )
        _screenState.value = ScreenState.Content(uiModel)
    }
}

data class LoginUIModel(
    var email: String? = null,
    var password: String? = null,
    var passwordVisible: Boolean = false,
)

sealed class LoginEvents {
    data class NavigateToHome(val clubId: String) : LoginEvents()
    class NavigateToSelectClub : LoginEvents()
}
